;
define("store_locator_upgrade.tpl", function(){});

